// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__twz8h","buttons":"SendReceipts_buttons__2r6cf","email":"SendReceipts_email__1a7a5","bookApptTitle":"SendReceipts_bookApptTitle__2sTb5"};